export default "__VITE_ASSET__eDtTcVQ1c26A0AX1IhNTOg__"